import { render } from "./BuyerQuoteDetailsView.vue?vue&type=template&id=5fcb3314"
import script from "./BuyerQuoteDetailsView.vue?vue&type=script&lang=js"
export * from "./BuyerQuoteDetailsView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__